import { storeStructure } from '../store/reducers';
import routes from '../routes/route';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';

export default {
  attributeName: 'ingestserver',
  isDragable: false,
  // canOpen: true,
  canOpen: true,
  canEdit: true,
  canCreate: false,
  isMultiSelectable:true,
  bulkDelete: true,
  canRemove: true,
  editURL: routes.INGEST_SERVER_EDIT,
  createPath: routes.INGEST_SERVER_NEW,
  editURL: routes.INGEST_SERVER_EDIT,
  // modifyURL:routes.LIVE_APPS,

  emptyMessage: "You don't have ingest servers configured yet, click on the +new button to make a new one.",
  fields: [
    {
      attributeName: 'id',
      label: 'ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '8rem',
      helpText: 'Id of the event.',
      canOrder: true,
      canFilter: true,
      exactWidth:'80px'
    },
    {
      attributeName: 'hostName',
      label: 'Host Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Host Name of the ingest server.',
      canOrder: true,
      canFilter: true,
      exactWidth:'180px'

    },
    {
      attributeName: 'ip',
      label: 'IP',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Ip for connection.',
      canOrder: true,
      canFilter: true,
      exactWidth:'120px'

    },
    {
      attributeName: 'from',
      label: 'From',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Who created the ingest server.',
      canOrder: true,
      canFilter: true,
      exactWidth:'120px'

    },
    {
      attributeName: 'last_connection',
      label: 'Last connection',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Last time the ingest server connect with the XMS.',
      canOrder: true,
      canFilter: true,
      exactWidth:'120px'

    },
    {
      attributeName: 'graphicsInfo',
      label: 'Graphics Info',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Graphics Information .',
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'osInfo',
      label: 'OS Info',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      helpText: 'Operating system Information .',
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'updated_at',
      label: 'Updated At',
      width: '12rem',
      helpText: 'Date of Live event update.',
      type: FormInputTypes.TIMESTAMP,
      canOrder: true,
      exactWidth:'120px'
    },
  ],
};
